import { Base } from '../base-component';
import './file-list-filter-topic.component.scss';

export class FileListFilterTopic extends Base {

	constructor(element: Element){

		super(element);

	}

	init(){

	}

	bindEvents() {

	}

}


// WEBPACK FOOTER //
// ./components/file-list-filter-topic/file-list-filter-topic.component.ts